// extracted by mini-css-extract-plugin
module.exports = {"root":"homepage-landing_root__2MCg2"};